<template>
	<div class="grid-content">
		<el-row>
			<el-col :span="24">
				<el-row :gutter="10">
					<el-col :span="6">
						<div class="dispatch">
							<div class="total">
								<span>调度列表</span>
								<div v-if="init" class="tongzhi">
									<div class="text">订单通知</div>
									<el-switch class="switch" v-model="notify" @change="changeNotify">
									</el-switch>
									<el-tooltip v-if="notify" class="item" effect="dark"
										content="只有在[订单管理]界面(本页面)，新订单才会通知" placement="top">
										<i class="el-icon-question"></i>
									</el-tooltip>
								</div>
							</div>
							<div class="list" v-loading="loading">
								<template v-if="init">
									<div v-if="list.length==0" class="nodata">暂无需调度的订单</div>
									<template v-else>
										<div v-for="(item,indexs) in list" class="item">
											<div class="box" :class="(index == indexs)?'active':''">
												<div class="content">
													<div class="ba">
														<template v-if="item.user.id">
															<img v-if="item.user.head" :src="item.user.head"
																class="avatar" style="cursor: pointer;"
																@click="orderDispatch(item.user.id)">
															<img v-else src="../../assets/custom_head.png"
																class="avatar" style="cursor: pointer;"
																@click="orderDispatch(item.user.id)">
														</template>
														<img v-else src="../../assets/custom_head.png" class="avatar">
														<div class="bab">
															<div class="baba">{{item.order_no}}</div>
															<div class="babb">
																<div>{{item.create_time}}</div>
															</div>
														</div>
														<div class="bac el-icon-close"
															@click="cancelDispatch(item.order_id,item.order_no)">
														</div>
													</div>
													<div class="bb">
														<div class="start">
															<div class="a">{{item.start_title}}</div>
															<div class="b">{{item.start_desc}}</div>
															<div class="c"></div>
														</div>
														<div class="driver">
															<div class="a">服务司机：</div>
															<div v-if="item.driver!=null" class="b">
																<span>{{item.driver.name}}</span>
																<i class="el-icon-s-flag"
																	:class="(item.look)?'look':''"></i>
															</div>
															<div v-else class="b">-</div>
														</div>
													</div>
												</div>
												<div class="bottom">
													<div class="l">
														<span @click="onDispatch(indexs)">
															<i class="el-icon-success"></i>
															选择
														</span>
													</div>
													<div class="r">
														<el-popover v-if="item.driver!=null" placement="bottom"
															trigger="hover">
															<div
																style="text-align: center;color: black;font-size: 0.875rem;">
																司机手机</div>
															<div
																style="text-align: center;color: black;font-size: 1.25rem;">
																{{item.driver.phone}}
															</div>
															<div class="link" slot="reference">
																<span class="el-icon-phone"></span>
																<span>司机</span>
															</div>
														</el-popover>
														<el-popover v-if="item.user.phone" placement="bottom"
															trigger="hover">
															<div
																style="text-align: center;color: black;font-size: 0.875rem;">
																客户手机</div>
															<div
																style="text-align: center;color: black;font-size: 1.25rem;">
																{{item.user.phone}}
															</div>
															<div class="link" slot="reference">
																<span class="el-icon-phone"></span>
																<span>客户</span>
															</div>
														</el-popover>
													</div>
												</div>
											</div>
										</div>
									</template>
								</template>
							</div>
						</div>
					</el-col>
					<el-col :span="18">
						<div class="map">
							<el-amap :amap-manager="map.amapManager" vid="amap" :center="map.center" :zoom="map.zoom"
								:zooms="[10,18]" :events="map.events">
							</el-amap>
							<div v-if="!add" class="add">
								<el-button size="small" @click="add = true">创建订单</el-button>
							</div>
							<div v-else class="add-tips">
								<div class="content">
									<div class="left">请拖动地图选择好客户位置，再点击右侧下一步填写客户联系方式</div>
									<div class="right">
										<el-button type="primary" size="mini" @click="addDispatch">下一步
										</el-button>
									</div>
								</div>
								<i class="close el-icon-close" @click="add = false"></i>
							</div>
							<div v-if="add" class="add-custom"></div>
						</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		AMapManager,
		lazyAMapApiLoaderInstance
	} from "vue-amap";
	var driverMarker = [];
	var customMarker = null;
	const amapManager = new AMapManager();
	export default {
		data() {
			const self = this;
			return {
				init: false,
				loading: true,
				index: -1,
				list: [],
				driver: [],
				notify: false,
				add: false,
				add_form: {},
				map: {
					amapManager,
					center: [116.397428, 39.909231],
					zoom: 12,
					events: {
						init() {
							lazyAMapApiLoaderInstance.load().then(() => {
								self.initMap();
							});
						}
					}
				}
			};
		},
		mounted() {
			driverMarker = [];
			customMarker = null;
		},
		methods: {
			changeNotify() {

			},
			initMap() {
				const that = this;
				const map = that.map.amapManager.getMap();
				const info = localStorage.getItem("_JIAZHI_info");
				if (Boolean(info)) {
					const adminInfo = JSON.parse(info);
					that.map.center = [adminInfo.location[1], adminInfo.location[0]];
					console.log("加载调度");
					that.loading = true;
					that.postDispatch();
				}
			},
			onDispatch(index) {
				const that = this;
				const map = that.map.amapManager.getMap();
				console.log("这里-" + index);
				if (that.index == index && that.index >= 0) {
					that.index = -1;
					//取消选择
					if (customMarker) {
						map.remove(customMarker);
						customMarker = null;
					}
				} else {
					console.log("这里1-" + index);
					that.index = index;
					if (map && that.list[index]) {
						console.log("这里2");
						//将地图移到客户点
						that.map.center = [that.list[index].start_lng, that.list[index].start_lat];
						if (customMarker) {
							customMarker.setAnimation("AMAP_ANIMATION_DROP");
							customMarker.setPosition(new AMap.LngLat(that.list[index].start_lng, that.list[index]
								.start_lat));
						} else {
							customMarker = new AMap.Marker({
								position: new AMap.LngLat(that.list[index].start_lng, that.list[index].start_lat),
								content: '<div class="mark"><i class="el-icon-user-solid"></i></div>',
								animation: "AMAP_ANIMATION_DROP",
								map: map
							});
						}
					}
				}
			},
			postDispatch() {
				const that = this;
				const map = that.map.amapManager.getMap();
				that.$post('orderDispatch').then(res => {
					that.loading = false;
					that.list = res.data.dispatch_list;
					that.driver = res.data.driver_list;
					//渲染司机地图
					if (map) {
						if (that.list.length <= 0 && that.index == -1 && customMarker) {
							that.index = -1;
							map.remove(customMarker);
							customMarker = null;
						}
						var newDriverMarker = [];
						const driver = res.data.driver_list;
						for (var i = 0; i < driver.length; i++) {
							var content;
							if (driver[i].cross) {
								content = "<div class='driver status" + driver[i].status +
									" cross' style='width: " + (driver[i].name.length * 0.85) + "rem;'>" +
									driver[i].name + "</div>"
							} else {
								content = "<div class='driver status" + driver[i].status +
									"' style='width: " +
									(
										driver[i].name.length * 0.85) + "rem;'>" + driver[i].name +
									"</div>";
							}
							if (!driverMarker[driver[i].id]) {
								var marker = new AMap.Marker({
									zIndex: (driver[i].status == 0 ? 1 : (driver[i].status == 1 ?
										1000 : (
											driver[i]
											.status == 2 ? 10 : 100))),
									position: new AMap.LngLat(driver[i].longitude, driver[i]
										.latitude),
									content: content,
									extData: driver[i],
									offset: new AMap.Pixel(-20, -22),
									map: map
								});
								//将司机点存储
								driverMarker[driver[i].id] = marker;
								newDriverMarker[driver[i].id] = marker;
								//司机点击事件
								AMap.event.addListener(marker, 'click', function(e) {
									if (that.index < 0) {
										that.$message.error("请从左侧选择需调度的订单");
									} else {
										const driver_data = e.target.getExtData();
										console.log(driver_data);
										// if (driver_data.status != 1) {
										// 	that.$message.error("司机【" + driver_data.name +
										// 		"】状态错误，无法对其调度");
										// } else {
										that.$msgbox({
											title: "提示",
											message: "确认将此订单调度给【" + driver_data.name +
												"】？",
											type: 'warning',
											showCancelButton: true,
											confirmButtonText: '确定',
											cancelButtonText: '取消',
											beforeClose: (action, instance, done) => {
												if (action === 'confirm') {
													instance.confirmButtonLoading =
														true;
													instance.confirmButtonText =
														'调度中...';
													that.$post('Order', {
														mode: "pai",
														oid: that.list[that.index]
															.order_id,
														driver: driver_data.id,
													}).then(res => {
														instance.confirmButtonLoading =
															false;
														instance.confirmButtonText =
															'确定';
														done();
														that.$message.success("调度成功");
														that.list[that.index].driver
															.name = driver_data.name;
														that.list[that.index].driver
															.phone = driver_data.phone;
														driverMarker[driver_data.id]
															.setContent(
																"<div class='driver status3' style='width: " +
																(driver_data.name
																	.length * 0.85) +
																"rem;'>" + driver_data
																.name + "</div>");
														that.index = -1;
													}).catch(e => {
														instance.confirmButtonLoading =
															false;
														instance.confirmButtonText =
															'确定';
														that.$message.error((e !=
																undefined && e
																.message !=
																undefined && e
																.message) ? e
															.message :
															"未知错误，请重试");
													});
												} else {
													instance.confirmButtonLoading = false;
													instance.confirmButtonText = '确定';
													done();
												}
											}
										}).then(action => {
											console.log("action", action);
										}).catch(e => {
											console.log("e", e);
										});
									}
								});
							} else {
								driverMarker[driver[i].id].setContent(content);
								driverMarker[driver[i].id].moveTo(new AMap.LngLat(driver[i].longitude,
									driver[i].latitude), 80); //更新点标记位置
								newDriverMarker[driver[i].id] = driverMarker[driver[i].id];
							}
						}
						driverMarker = newDriverMarker; //覆盖
						if (!that.init) {
							map.setZoom(12);
						}
					}
					that.init = true;
				}).catch(e => {
					that.init = true;
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message : "未知错误，请重试",
						'提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.dispatch {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 38rem;
		box-sizing: border-box;
		border: 1px #eee solid;
		background-color: #F8F8F8;
	}

	.dispatch .total {
		position: relative;
		font-size: 0.875rem;
		font-weight: bold;
		line-height: 3rem;
		padding: 0 0.625rem;
		background-color: white;
		border-bottom: 1px #eee solid;
	}

	.dispatch .total .tongzhi {
		display: flex;
		position: absolute;
		top: 0;
		right: 0.625rem;
		height: 3rem;
		align-items: center;
	}

	.dispatch .total .tongzhi .switch {
		transform: scale(.8);
	}

	.dispatch .total .tongzhi .text {
		color: #666;
		font-size: 0.75rem;
		margin-left: 0.2rem;
	}

	.dispatch .list {
		flex: 1 1 0%;
		overflow: auto;
		padding: 0 0.625rem;
	}

	.dispatch .list::-webkit-scrollbar {
		width: 0.375rem;
		height: 0.375rem;
	}

	.dispatch .list::-webkit-scrollbar-thumb {
		border-radius: 0.625rem;
		background-color: #eee;
		-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.2);
	}

	.dispatch .list .nodata {
		color: #999999;
		font-size: 0.875rem;
		text-align: center;
		line-height: 6.25rem;
	}

	.dispatch .list .item {
		padding-bottom: 0.625rem;
	}

	.dispatch .list .item:nth-child(1) {
		padding-top: 0.625rem;
	}

	.dispatch .list .item .box {
		display: flex;
		flex-direction: column;
		min-height: 6.25rem;
		border-radius: 0.25rem;
		background-color: white;
		border: 2px white solid;
	}

	.dispatch .list .item .box.active {
		border: 2px #00AEFF solid;
	}

	.dispatch .list .item .box .content {
		flex: 1 1 0%;
	}

	.dispatch .list .item .box .content .ba {
		display: flex;
		align-items: center;
		font-size: 0.75rem;
		padding: 0.3125rem 0.3125rem;
		border-bottom: 1px #EEEEEE solid;
	}

	.dispatch .list .item .box .content .ba .avatar {
		width: 2.2rem;
		height: 2.2rem;
		border-radius: 0.375rem;
	}

	.dispatch .list .item .box .content .ba .bab {
		flex: 1;
		margin-left: 0.3125rem;
	}

	.dispatch .list .item .box .content .ba .bab .baba {
		font-weight: bold;
	}

	.dispatch .list .item .box .content .ba .bab .babb {
		position: relative;
		height: 0.9rem;
	}

	.dispatch .list .item .box .content .ba .bab .babb div {
		position: absolute;
		color: #999;
		top: -0.1rem;
		left: -0.4375rem;
		transform: scale(.7);
	}

	.dispatch .list .item .box .content .ba .bac {
		font-size: 1.25rem;
		cursor: pointer;
	}

	.dispatch .list .item .box .content .bb {
		padding: 0.75rem 0.3125rem;
	}

	.dispatch .list .item .box .content .bb .start {
		position: relative;
		font-size: 0.125rem;
		padding-left: 0.625rem;
	}

	.dispatch .list .item .box .content .bb .start .a {
		font-weight: bold;
	}

	.dispatch .list .item .box .content .bb .start .b {
		color: #999;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.dispatch .list .item .box .content .bb .start .c {
		position: absolute;
		top: 50%;
		left: 0;
		width: 0.3125rem;
		height: 0.3125rem;
		margin-top: -0.1875rem;
		border-radius: 50%;
		background-color: #67C23A;
	}

	.dispatch .list .item .box .content .bb .driver {
		display: flex;
		margin-top: 0.625rem;
		font-size: 0.75rem;
		padding-left: 0.625rem;
	}

	.dispatch .list .item .box .content .bb .driver .a {
		color: #99a9bf;
	}

	.dispatch .list .item .box .content .bb .driver .b i {
		color: #999999;
		margin-left: 0.3125rem;
	}

	.dispatch .list .item .box .content .bb .driver .b i.look {
		color: #67c23a;
	}

	.dispatch .list .item .box .bottom {
		display: flex;
		align-items: center;
		height: 1.875rem;
		padding: 0 0.3125rem;
		border-top: 1px #EEEEEE solid;
	}

	.dispatch .list .item .box .bottom .l {
		flex: 1;
		color: #ccc;
	}

	.dispatch .list .item .box.active .bottom .l {
		color: #00AEFF;
	}

	.dispatch .list .item .box .bottom .l span {
		cursor: pointer;
		font-size: 0.75rem;
	}

	.dispatch .list .item .box .bottom .l i {
		font-size: 0.9rem;
	}

	.dispatch .list .item .box .bottom .r {
		display: flex;
		font-size: 0.75rem;
	}

	.dispatch .list .item .box .bottom .r .link {
		color: #333;
		margin-left: 0.6rem;
		margin-right: 0;
		background-color: #F9F9F9;
		border-radius: 0.25rem;
		padding: 0.125rem 0.3125rem;
		border: 1px #ccc solid;
	}

	.map {
		position: relative;
		width: 100%;
		height: 38rem;
	}

	.map .add {
		position: absolute;
		top: 0;
		left: 0.625rem;
		display: flex;
		align-items: center;
		height: 3rem;
	}

	.map .add-tips {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 0;
		width: 100%;
		height: 3.05rem;
		color: white;
		font-size: 0.875rem;
		background-color: rgba(0, 0, 0, .8);
	}

	.map .add-tips .content {
		display: flex;
		align-items: center;
	}

	.map .add-tips .content .left {
		margin-right: 0.8rem;
	}

	.map .add-tips .close {
		position: absolute;
		right: 0;
		cursor: pointer;
		padding: 0.625rem;
		font-size: 1.25rem;
	}

	.map .add-custom {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 1.75rem;
		height: 2.375rem;
		margin-top: -2.375rem;
		margin-left: -0.875rem;
		background-image: url(../../assets/map_custom.png);
		background-size: 100% 100%;
	}

	.map>>>.driver {
		color: #fff;
		font-size: 0.75rem;
		text-align: center;
		padding: 0.05rem 0.2rem 0.1rem 0.2rem;
		background-color: red;
		border-radius: 2px;
		position: relative;
	}

	.map>>>.driver.cross {
		color: black;
	}

	.map>>>.driver.status1 {
		background-color: #07C160;
	}

	.map>>>.driver.status2 {
		background-color: #00aeff;
	}

	.map>>>.driver.status3 {
		background-color: #FF8E43;
	}

	.map>>>.driver::before {
		content: '';
		width: 0;
		height: 0;
		border: 5px solid;
		position: absolute;
		bottom: -10px;
		left: 50%;
		margin-left: -5px;
		z-index: 1;
		border-color: red transparent transparent;
	}

	.map>>>.driver::after {
		position: absolute;
		content: '';
		width: 6px;
		height: 3px;
		background: rgba(0, 0, 0, .6);
		bottom: -7px;
		left: 50%;
		margin-left: -3px;
		border-radius: 50%;
	}

	.map>>>.driver.status1::before {
		border-color: #07C160 transparent transparent;
	}

	.map>>>.driver.status2::before {
		border-color: #00aeff transparent transparent;
	}

	.map>>>.driver.status3::before {
		border-color: #FF8E43 transparent transparent;
	}

	.map>>>.mark {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 50%;
		left: 50%;
		width: 1.625rem;
		height: 1.625rem;
		margin-top: -1.625rem;
		margin-left: -0.8125rem;
		border-radius: 50%;
		background-color: black;
	}

	.map>>>.mark::after {
		position: absolute;
		content: "";
		width: 3px;
		height: 10px;
		bottom: -10px;
		background-color: black;
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.map>>>.mark i {
		color: white;
		font-size: 1rem;
	}

	>>>.map-start,
	>>>.map-end {
		width: 1.875rem;
		line-height: 1.875rem;
		color: #fff;
		font-size: 0.75rem;
		text-align: center;
		border-radius: 3.125rem;
		background-color: #07C160;
		position: relative;
	}

	>>>.map-end {
		background-color: red;
	}

	>>>.map-start::before,
	>>>.map-end::before {
		content: '';
		width: 0;
		height: 0;
		border: 5px solid;
		position: absolute;
		bottom: -9px;
		left: 50%;
		margin-left: -5px;
		border-color: #07C160 transparent transparent;
	}

	>>>.map-end::before {
		border-color: red transparent transparent;
	}
</style>
